import CategoryCard, { CategoryCardProps } from './CategoryCard';
import SkillCard, { SkillCardProps } from './SkillCard';
import './MySkillsGrid.css';

export interface MySkillsCategory {
  category: CategoryCardProps;
  skills: SkillCardProps[];
}

export interface MySkillsGridProps {
  categories: MySkillsCategory[];
  onToggle?: (skillName: string, agentName: string, equip: boolean) => Promise<void>;
}

export default function MySkillsGrid({ categories, onToggle }: MySkillsGridProps) {
  return (
    <div className="my-skills-grid">
      {categories.map((cat) => {
        const firstRowSkills = cat.skills.slice(0, 2);
        const remainingSkills = cat.skills.slice(2);
        const extraRows: SkillCardProps[][] = [];
        for (let i = 0; i < remainingSkills.length; i += 3) {
          extraRows.push(remainingSkills.slice(i, i + 3));
        }

        return (
          <div key={cat.category.title} className="my-skills-grid__section">
            <div className="my-skills-grid__row my-skills-grid__row--first">
              <div className="my-skills-grid__category-cell">
                <CategoryCard {...cat.category} />
              </div>
              {firstRowSkills.map((skill, i) => (
                <div key={`${skill.skillName || skill.title}-${i}`} className="my-skills-grid__card-cell">
                  <SkillCard {...skill} onToggle={onToggle} />
                </div>
              ))}
            </div>
            {extraRows.map((row, rowIdx) => (
              <div key={rowIdx} className="my-skills-grid__row">
                {row.map((skill, i) => (
                  <div key={`${skill.skillName || skill.title}-${rowIdx}-${i}`} className="my-skills-grid__card-cell">
                    <SkillCard {...skill} onToggle={onToggle} />
                  </div>
                ))}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
